var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('i',{class:`iconic ${_vm.mapClass()}`,style:(`${_vm.setSize()}`),domProps:{"innerHTML":_vm._s(`${_vm.myIcon(_vm.name)}`)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }